import { Address } from '@bybeam/platform-types';
import { optionalField } from '@platform-ui-common/hooks/useForm/fields.js';
import { unflatten } from 'flat';

function addressFormTransform(address?: Address, key = 'address') {
  const flatFormInit = Object.fromEntries(
    Object.entries(address ?? {})
      .filter(([fieldKey, _]) => !['id', '__typename', 'incomeLimitArea'].includes(fieldKey))
      .map(([fieldKey, value]) => [`${key}.${fieldKey}`, value]),
  );

  const validation = {
    [`${key}.addressLine1`]: optionalField(),
    [`${key}.addressLine2`]: optionalField(),
    [`${key}.city`]: optionalField(),
    [`${key}.county`]: optionalField(),
    [`${key}.state`]: optionalField(),
    [`${key}.zip`]: optionalField(),
  };

  const buildObject = (formData) => unflatten(formData)?.[key] as Address;

  return { buildObject, flatFormInit, validation };
}

export { addressFormTransform };
